export default __webpack_public_path__ + "static/media/img-18.58d02af2.jpg";